// extracted by mini-css-extract-plugin
export default {"addToCartControl":"D0-z","giftCard":"E0-z","btnContainer":"F0-z","cartButton":"G0-z","disabled":"H0-z"};